import { render, staticRenderFns } from "./InvoiceIssuanceTable.vue?vue&type=template&id=474040f7"
import script from "./InvoiceIssuanceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceIssuanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports